module.exports = __webpack_public_path__ + "img/questionnaire-icon.d61cb0a4.svg";